import { jsx as _jsx } from "react/jsx-runtime";
import { ManagePage } from "@/views/manage";
import { CityCreatePage } from "@/views/manage/cities/CityCreatePage";
import { CityEditPage } from "@/views/manage/cities/CityEditPage";
import { CityListPage } from "@/views/manage/cities/CityListPage";
import { SportCreatePage } from "@/views/manage/sports/SportCreatePage";
import { SportEditPage } from "@/views/manage/sports/SportEditPage";
import { SportListPage } from "@/views/manage/sports/SportListPage";
import { ProtectedRoute } from "../ProtectedRoute";
import { RoutesList } from "../routesList";
/** Роуты для упавления */
export var routesManage = [
    {
        path: RoutesList.Manage.getManage(),
        element: (_jsx(ProtectedRoute, { component: ManagePage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Manage.getSportsList(),
        element: (_jsx(ProtectedRoute, { component: SportListPage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Manage.getSportAdd(),
        element: (_jsx(ProtectedRoute, { component: SportCreatePage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Manage.getSportEdit(":sportId"),
        element: (_jsx(ProtectedRoute, { component: SportEditPage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Manage.getCitiesList(),
        element: (_jsx(ProtectedRoute, { component: CityListPage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Manage.getCityAdd(),
        element: (_jsx(ProtectedRoute, { component: CityCreatePage, allowedRoles: ["place-manager"] })),
    },
    {
        path: RoutesList.Manage.getCityEdit(":cityId"),
        element: (_jsx(ProtectedRoute, { component: CityEditPage, allowedRoles: ["place-manager"] })),
    },
];
